import axios from 'axios';
/**
 * @name 공통API 호출 유틸
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    // 'x-ssp-token': '',
    // 'x-ssp-refresh-token': '',
    'x-ssp-channel': '1',
    'Content-Type': 'application/json; charset=utf-8',
  },
});

// 응답 인터셉터
api.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    return Promise.reject(error);
  },
);

export default api;
